import {Component, EventEmitter, Input, Output} from '@angular/core';
import {UiDocumentItem, IoniconsFilled, PtEntity, PtPermissions, PtUiAppRoutes} from '@pt/pt-models';
import {DeleteService} from "../../../../services";
import {DocAccess} from "it/primatoo/openapi/api/org/schemas/common/DocAccess";
import {DocumentItemUtils} from "@pt/pt-core";

@Component({
  selector: 'pt-delete-selected-rows',
  template: `
    <button type='button' (click)='deleteMultiple()'
            *ngxPermissionsOnly='userCanDelete'
            [disabled]='selectedRows === undefined || selectedRows?.length === 0 || loading'
            class='btn btn-outline-danger btn-sm d-flex align-items-center'>
      <pt-icon class="hstack" [size]="14" [key]='IconTrash' *ngIf="!loading"></pt-icon>
      <div class='spinner-border' *ngIf="loading" style="width: 17px; height: 17px;" role='status'>
        <span class='visually-hidden'>Loading...</span>
      </div>
      <span class="mx-1">{{ 'BUTTON.DELETE' | translate }}</span>
      <span *ngIf='selectedRows?.length > 0'>({{ selectedRows.length }})</span>
    </button>
  `
})
export class DeleteSelectedRowsComponent {
  @Input() entity: PtEntity;
  @Input() selectedRows: any[] = [];

  @Output() reloadTable: EventEmitter<boolean> = new EventEmitter<boolean>();

  public IconTrash = IoniconsFilled.trash;
  public userCanDelete: PtPermissions[] = [];

  public loading = false;

  constructor(
    private deleteService: DeleteService
  ) {
    const href = window.location.href;
    switch (true) {
      case href.includes(PtUiAppRoutes.ADMINISTRATION_AND_CONFIGURATION):
        this.userCanDelete.push(PtPermissions.ENABLE_FOR_SYSTEM);
        this.userCanDelete.push(PtPermissions.ENABLE_FOR_ADMIN);
        break;
      case href.includes(PtUiAppRoutes.BUSINESS_MANAGEMENT):
        // non gestisto i permessi qui, se non hai il permesso di cancellare scoppia dopo ed è gestito
        break;
      default:
        this.userCanDelete.push(PtPermissions.DPG);
    }

  }

  public deleteMultiple() {
    this.loading = true;
    let docDeleteItem: UiDocumentItem[] = [];
    let entityDeleteItem: UiDocumentItem[] = [];
    switch (this.entity) {
      case 'aiAssessment':
        docDeleteItem = this.selectedRows.map(row => DocumentItemUtils.convertDocument(row, DocAccess.FULL));
        break;
      case 'appAssessment':
        docDeleteItem = this.selectedRows.map(row => DocumentItemUtils.convertDocument(row, DocAccess.FULL));
        break;
      case 'covidAssessment':
        docDeleteItem = this.selectedRows.map(row => DocumentItemUtils.convertDocument(row, DocAccess.FULL));
        break;
      case 'treatmentsHolder':
      case 'treatmentsResponsible':
      case 'treatmentsSubResponsible':
      case 'projectCards':
        docDeleteItem = this.selectedRows.map(row => DocumentItemUtils.convertDocument(row, DocAccess.FULL));
        break;
      case 'globalMeasureCheck':
        docDeleteItem = this.selectedRows.map(row => DocumentItemUtils.convertDocument(row, DocAccess.FULL));
        break;
      default:
        entityDeleteItem = this.selectedRows;
    }

    if (entityDeleteItem.length > 0) {
      this.deleteService.deleteEntity(this.entity, entityDeleteItem).subscribe({
        next: (response) => {
          if (response) {
            this.reloadTable.emit(true);
          }
          this.loading = false
        },
        error: () => this.loading = false
      });
    }

    if (docDeleteItem.length > 0) {
      this.deleteService.deleteDocument(this.entity, docDeleteItem).subscribe({
        next: (response) => {
          if (response) {
            this.reloadTable.emit(true);
          }
          this.loading = false;
        },
        error: () => this.loading = false
      });
    }
  }

}
